<!--
 * @Author: DQL
 * @Date: 2020-03-18 10:31:26
 * @LastEditors: DQL
 * @LastEditTime: 2022-09-28 15:16:53
 * @Description: 机构管理--编辑机构信息
 -->
<template>
  <div class="l-page--inner l-page--detail">
    <!-- 页面头部 Start -->
    <div class="l-page__header c-page__header">
      <!-- 页面标题 -->
      <h2 class="c-page__header-title">
        修改
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div class="c-page__header-btns">
        <el-button
          type="primary"
          icon="kestrel-icon ki-save"
          @click="handleSave()"
        >
          保存
        </el-button>
        <el-button
          icon="kestrel-icon ki-close"
          @click="handleClickSwitchToView()"
        >
          关闭
        </el-button>
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 页面主内容：详情 Start -->
    <div class="l-page__body l-page--detail__body">
      <hm-page-card class="c-card--detail">
        <el-form
          ref="fd"
          class="c-form"
          :model="fd"
          :rules="fdRules"
          :inline="true"
          label-position="right"
          label-width="160px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              v-if="fd.parentDeptCode && fd.parentDeptName"
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="上级组织代码"
              >
                <span class="c-form__read">
                  {{ fd.parentDeptCode }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              v-if="fd.parentDeptName"
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="上级组织名称"
              >
                <span class="c-form__read">
                  {{ fd.parentDeptName }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="组织代码"
                prop="deptCode"
              >
                <span class="c-form__read">
                  {{ fd.deptCode }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="组织名称"
                prop="deptName"
              >
                <el-input
                  v-model.trim="fd.deptName"
                  class="c-form__input"
                  placeholder="组织名称"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="组织简称"
                prop="deptShortName"
              >
                <el-input
                  v-model.trim="fd.deptShortName"
                  class="c-form__input"
                  placeholder="组织简称"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="组织标志"
                prop="deptType"
              >
                <el-radio-group
                  v-model="fd.deptType"
                  class="c-form__radio-group"
                >
                  <el-radio
                    v-for="(value,key) in deptType"
                    :key="key"
                    :label="value.id"
                  >
                    {{ value.text }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="统一社会信用代码"
                prop="TYSHXYDM"
              >
                <el-input
                  v-model="fd.TYSHXYDM"
                  class="c-form__input"
                  autocomplete="off"
                  placeholder="请输入统一社会信用代码"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="所属区域"
                prop="AREA"
              >
                <select-address
                  ref="SelectAddress"
                  v-model="fd.AREA"
                  required
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="公司地址"
                prop="GS_DZ"
              >
                <el-input
                  v-model="fd.GS_DZ"
                  class="c-form__input"
                  autocomplete="off"
                  placeholder="请输入公司地址"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="法定代表人"
                prop="FDDBR"
              >
                <el-input
                  v-model="fd.FDDBR"
                  class="c-form__input"
                  autocomplete="off"
                  placeholder="请输入法定代表人"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="联系人"
                prop="LXR"
              >
                <el-input
                  v-model="fd.LXR"
                  class="c-form__input"
                  placeholder="请输入联系人"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="联系电话"
                prop="LXDH"
              >
                <el-input
                  v-model.trim="fd.LXDH"
                  class="c-form__input"
                  placeholder="联系电话"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="传真"
                prop="CZ"
              >
                <el-input
                  v-model.trim="fd.CZ"
                  class="c-form__input"
                  placeholder="传真"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="邮编"
                prop="YB"
              >
                <el-input
                  v-model.trim="fd.YB"
                  class="c-form__input"
                  placeholder="请输入邮编"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="场地面积（m²）"
                prop="CD_MJ"
              >
                <el-input
                  v-model="fd.CD_MJ"
                  class="c-form__input"
                  autocomplete="off"
                  placeholder="请输入场地面积"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="法人证件"
                prop="frzjFiles"
              >
                <image-upload
                  ref="attrs"
                  v-model="fd.frzjFiles"
                  multiple-file
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="image/*"
                  :data="uploadFd"
                  list-type="picture-card"
                >
                  <i
                    slot="default"
                    class="el-icon-plus"
                  />
                </image-upload>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="营业执照"
                prop="yyzzFiles"
              >
                <image-upload
                  ref="attrs"
                  v-model="fd.yyzzFiles"
                  multiple-file
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="image/*"
                  :data="uploadFd"
                  list-type="picture-card"
                >
                  <i
                    slot="default"
                    class="el-icon-plus"
                  />
                </image-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
    <!-- 页面主内容：详情 End -->
  </div>
</template>

<script>
import { deptService } from '../dept.service';

export default {
  name: 'AttrEditDept',
  props: {
    deptCode: {
      type: String,
      default: null
    },
    isLoading: {
      type: Boolean
    },
    canNotLeavePage: {
      type: Boolean
    },
    // 扩展字段列表
    attrDeptList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data () {
    return {
      /* 表单参数 Start */
      fd: {
        parentDeptCode: null,
        parentDeptName: null,
        deptCode: null,
        deptName: null,
        deptShortName: null,
        deptType: '1',
        deptTypeCode: '1',
        effectStartDate: null,
        effectEndDate: null,
        TYSHXYDM: null,
        LXR: null,
        LXDH: null,
        CZ: null,
        YB: null,
        YYZZ: [],
        AREA: null,
        AREA_NAME: null,
        GS_DZ: null,
        FDDBR: null,
        CD_MJ: null,
        FRZJ: null,
        frzjFiles: [],
        yyzzFiles: []
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        deptName: [
          this.$validUtils.required('组织名称'),
          this.$HMValidator.maxLength('组织名称', 100)
        ],
        deptShortName: [
          this.$HMValidator.maxLength('组织简称', 50)
        ],
        deptType: [
          this.$validUtils.required('组织标志')
        ],
        email: [
          this.$HMValidator.email('电子邮箱')
        ],
        postcode: [
          this.$HMValidator.postcode('邮政编码')
        ],
        effectStartDate: [
          this.$validUtils.required('有效期起'),
          this.$HMValidator.startTime(this, 'fd', 'effectEndDate', ['有效期起', '有效期止'])
        ],
        effectEndDate: [
          this.$validUtils.required('有效期止'),
          this.$HMValidator.endTime(this, 'fd', 'effectStartDate', ['有效期起', '有效期止'])
        ],
        AREA: [this.$validUtils.required('所属区域')],
        TYSHXYDM: [
          this.$validUtils.required('统一社会信用代码'),
          this.$HMValidator.tyshxydm('统一社会信用代码')
        ],
        CD_MJ: [
          this.$validUtils.positiveNumber('场地面积')
        ]
      },
      /* 表单校验规则 End */

      /* 文件服务器对接参数 Start */
      uploadFd: { // 上传服务入参
        meta: [
          {
            key: 'type',
            value: 'fileId'
          }
        ]
      }
      /* 文件服务器对接参数 End */
    };
  },
  computed: {
    // 部门类型
    deptType () {
      const enums = this.$HMStoreService.getEnums();
      if (enums && enums.DEPT_TYPE) {
        return enums.DEPT_TYPE;
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 初始化
     * 1.后台获取机构信息
     * 2.初始化扩展字段，把扩展的机构信息整理至扩展属性对象里面
     * @param {*}
     * @return {*}
     */
    init () {
      // 回调页面开启loading状态
      this.$emit('update:isLoading', true);
      this.getDeptInfo();
    },
    /**
     * @description: 获取组织信息
     * @param {*}
     * @return {*}
     */
    getDeptInfo () {
      return deptService.get(this.deptCode)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
          this.fd.frzjFiles = rsp.data.FRZJ ? rsp.data.FRZJ.split(';') : [];
          this.fd.yyzzFiles = rsp.data.YYZZ ? rsp.data.YYZZ.split(';') : [];
          Promise.resolve();
        })
        .catch(err => {
          console.error('获取组织机构数据出错', err);
          Promise.reject(err);
        })
        .finally(() => {
          // 回调页面开启loading状态
          this.$emit('update:isLoading', false);
        });
    },
    /**
     * @description: 保存
     * @param {*}
     * @return {*}
     */
    handleSave () {
      const _this = this;
      const attrs = Object.assign({}, {
        TYSHXYDM: null,
        LXR: null,
        LXDH: null,
        CZ: null,
        YB: null,
        YYZZ: null,
        AREA: null,
        AREA_NAME: null,
        GS_DZ: null,
        FDDBR: null,
        CD_MJ: null,
        FRZJ: null
      }, this.fd);
      attrs.FRZJ = this.fd.frzjFiles.join(';');
      attrs.YYZZ = this.fd.yyzzFiles.join(';');
      attrs.AREA_NAME = this.$refs.SelectAddress.getAddressMc().join(' ');
      this.fd.attrs = attrs;
      _this.$refs.fd.validate((valid) => {
        if (valid) {
          // 回调页面开启loading状态
          _this.$emit('update:isLoading', true);
          deptService.update(_this.fd)
            .then(rsp => {
              _this.$alert('更新成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              // 回调页面重载
              _this.$emit('reloadView', _this.fd.deptCode);
            })
            .catch(err => {
              // 回调页面关闭loading状态
              _this.$emit('update:isLoading', false);
              console.error('机构部门编辑保存失败', err);
            });
        }
      });
    },
    /**
     * @description: 触发切换页面状态为查看菜单
     * @param {*}
     * @return {*}
     */
    handleClickSwitchToView () {
      this.$emit('switch', 'viewDept');
    }
  },
  watch: {
    // 深度监听表单
    fd: {
      handler (newVal, oldVal) {
        if (oldVal.deptCode) {
          this.$emit('update:canNotLeavePage', true);
        }
      },
      deep: true
    }
  },
  created () {
    this.init();
  }
};
</script>
